"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUrlParams = void 0;
const react_router_dom_1 = require("react-router-dom");
const useUrlParams = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const urlParams = new URLSearchParams(location.search);
    return {
        disableParticipateButton: urlParams.get('disable_participate_button') === 'true',
        disabledParticipateButtonText: urlParams.get('disabled_participate_button_text'),
    };
};
exports.useUrlParams = useUrlParams;
